import { Availability } from './CalendarAvailability';
import { consoleLogInDev } from 'shared';

export enum AvailabilityCategories {
    EarlyBird,
    NightOwl,
    Flexible,
}

const weekendDays: number[] = [5, 6];
const earlyKeys: string[] = ['t_06_09', 't_09_12', 't_12_15', 't_15_18'];
const overlapKey: string = 't_15_18';
const nightKeys: string[] = ['t_18_21', 't_21_24'];

export function getAvailabilityCategory(availability: Availability[]) {
    let earlyCount = 0;
    let lateCount = 0;

    if (availability) {
        availability.forEach((avail: Availability) => {
            try {
                if (avail['date']) {
                    let dayOfWeek = new Date(avail['date']).getDay();
                    earlyKeys.forEach((item) => {
                        if (avail[item as keyof typeof avail]) {
                            if (weekendDays.includes(dayOfWeek)) {
                                lateCount++;
                            } else {
                                earlyCount++;
                            }
                        }
                    });
                    nightKeys.forEach((item) => {
                        if (avail[item as keyof typeof avail]) {
                            lateCount++;
                        }
                    });
                    if (avail[overlapKey as keyof typeof avail] && weekendDays.includes(dayOfWeek)) {
                        lateCount++;
                    }
                }
            } catch (e) {
                consoleLogInDev(e);
            }
        });
    }

    if (earlyCount && !lateCount) {
        return AvailabilityCategories.EarlyBird;
    } else if (!earlyCount && lateCount) {
        return AvailabilityCategories.NightOwl;
    } else {
        return AvailabilityCategories.Flexible;
    }
}
